import {useClientAccountOverview} from "@twigsby/client-data";
import {Avatar, AvatarSize} from "@twigsby/frontend-framework";

type UserAvatarType = {
    rounded?: boolean;
    size?: AvatarSize;
}

const UserAvatar = (props: UserAvatarType) => {
    const { data } = useClientAccountOverview();

    return (
        <Avatar
            title={data?.name as string || 'Username'}
            size={props.size}
            rounded={props.rounded}
            imageSrc={data?.avatarURL}
        />
    )
}

export { UserAvatar }
